<div class="app-component app-container" >

  <div class="container-fluid full-app-container">
    <header>
      <app-website-menu></app-website-menu>
    </header>
    
    <main id="main-content">
      <lib-breadcrumbs class="tvs-breadcrumbs"></lib-breadcrumbs>
      <router-outlet></router-outlet>
    </main>

  </div>
  <footer>
    <app-website-footer></app-website-footer>
  </footer>
  
  <div class="tvs-up" [ngClass]="{'active':isScroll}">
    <a (click)="scrollTopWindow()" href="javascript:void(0)">
      <div class="tvs-round-btn-yellow tvs-btn-up">
      </div>
    </a>
  </div>
</div>
